import dfilehelper from "./dfilehelper";
import dmath from "./dmath";
export default {
    formatString(str, replace_list)
    {
        if (!replace_list)
            return str;

        for (var key in replace_list)
        {
            str = str.replace("{{" + key + "}}", replace_list[ key ]);
        }
        return str;
    },
    formatFilesize(size, decimals){
        return dfilehelper.formatedFilesize(size, decimals);
    },
    round(number, decimals){
        return dmath.round(number, decimals);
    },
    formatCurrency(number, decimals){
        return dmath.formatCurrency(number, decimals);
    },
    formatPercentage(number, decimals){
        return dmath.formatPercentage(number, decimals);
    },
    formatCustom(number, decimals, suffix){
        return dmath.formatCustom(number, decimals, suffix);
    },
    urlSafe(text){
        return text
        .replace(/å|ä/gi, "a") // Replace å, ä (both uppercase & lowercase) with a
        .replace(/ö/gi, "o")   // Replace ö (both uppercase & lowercase) with o
        .replace(/[^a-zA-Z0-9]/g, "_"); // Replace all other non-alphanumeric characters with "_"
    }
} 